export default "__VITE_ASSET__ae863312__"